'use client';

/**
 * Client-side build info badge — renders the Git SHA with copy-to-clipboard.
 *
 * This file is only loaded when the `build_info` flag is enabled server-side.
 * Keeping the SHA reference isolated here ensures it never reaches the client
 * bundle when the flag is off.
 */

import { useCallback, useState } from 'react';

const BUILD_SHA = process.env.NEXT_PUBLIC_BUILD_SHA || 'unknown';
const SHORT_SHA = BUILD_SHA.slice(0, 7);

const BuildInfoBadgeClient = () => {
  const [copied, setCopied] = useState(false);

  const handleClick = useCallback(() => {
    navigator.clipboard.writeText(BUILD_SHA).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    });
  }, []);

  return (
    <button
      type="button"
      onClick={handleClick}
      title={`Build: ${BUILD_SHA}`}
      className="ph-no-capture cursor-pointer fixed bottom-8 right-3 z-[60] rounded bg-surface-primary-default px-2 py-1 font-mono text-[10px] font-bold text-white shadow-sm opacity-90 transition-opacity hover:opacity-100"
    >
      {copied ? 'Copied!' : SHORT_SHA}
    </button>
  );
};

export default BuildInfoBadgeClient;
